import React, { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";

export default function ReviewsDrawer({
  open,
  onClose,
  fornitoreId,
  fornitoreNome,
  onSaved,
}) {
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]); // [{id, rating, comment, created_at, user_name}]
  const [myRating, setMyRating] = useState(0);
  const [myComment, setMyComment] = useState("");
  // { can_review, reason, my_review } dal server; null = non verificato / non loggato
  const [eligibility, setEligibility] = useState(null);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const avg = useMemo(() => {
    if (!list.length) return 0;
    return list.reduce((a, r) => a + r.rating, 0) / list.length;
  }, [list]);

  useEffect(() => {
    if (!open || !fornitoreId) return;
    (async () => {
      try {
        setLoading(true);
        const r = await fetch(
          `${API_BASE}/api/fornitori/${fornitoreId}/reviews`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (!r.ok) throw new Error("Errore caricamento recensioni");
        const data = await r.json();
        setList(Array.isArray(data) ? data : []);
      } catch (e) {
        toast.error("Impossibile caricare le recensioni");
      } finally {
        setLoading(false);
      }
    })();
  }, [open, fornitoreId, token]);

  // Il form compare solo a chi può recensire (cliente con ordine consegnato).
  useEffect(() => {
    if (!open || !fornitoreId || !token) {
      setEligibility(null);
      return;
    }
    (async () => {
      try {
        const r = await fetch(
          `${API_BASE}/api/fornitori/${fornitoreId}/reviews/eligibility`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!r.ok) throw new Error("eligibility");
        const data = await r.json();
        setEligibility(data);
        setMyRating(Number(data?.my_review?.rating) || 0);
        setMyComment(data?.my_review?.comment || "");
      } catch {
        setEligibility(null);
      }
    })();
  }, [open, fornitoreId, token]);

  const canReview = !!eligibility?.can_review;
  const hasMyReview = !!eligibility?.my_review;

  const submitReview = async (e) => {
    e.preventDefault();
    if (myRating < 1 || myRating > 5) {
      toast.error("Seleziona un voto da 1 a 5");
      return;
    }
    try {
      const r = await fetch(
        `${API_BASE}/api/fornitori/${fornitoreId}/reviews`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ rating: myRating, comment: myComment || "" }),
        }
      );
      const saved = await r.json().catch(() => null);
      if (!r.ok) {
        toast.error(saved?.error || "Errore nell’invio della recensione");
        return;
      }
      toast.success(saved?.updated ? "Recensione aggiornata" : "Recensione inviata");
      if (saved?.review) {
        setEligibility((prev) => ({ ...(prev || {}), can_review: true, my_review: saved.review }));
        onSaved?.(saved.review);
      }
      // ricarica elenco
      const r2 = await fetch(
        `${API_BASE}/api/fornitori/${fornitoreId}/reviews`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data2 = await r2.json();
      setList(Array.isArray(data2) ? data2 : []);
    } catch (e) {
      toast.error("Errore nell’invio della recensione");
    }
  };

  if (!open) return null;

  return (
    <div style={backdrop} onClick={onClose}>
      <aside style={panel} onClick={(e) => e.stopPropagation()}>
        <div style={panelHeader}>
          <div>
            <div style={{ fontWeight: 800, fontSize: 18 }}>
              {fornitoreNome || "Recensioni fornitore"}
            </div>
            <div style={{ color: "#666", fontSize: 13 }}>
              Media: {avg ? avg.toFixed(1) : "—"} ({list.length})
            </div>
          </div>
          <button onClick={onClose} style={xBtn} aria-label="Chiudi">
            ✕
          </button>
        </div>

        <div style={{ overflow: "auto", flex: 1 }}>
          {loading ? (
            <div style={{ padding: 12 }}>Caricamento…</div>
          ) : list.length === 0 ? (
            <div style={{ padding: 12, color: "#666" }}>
              {canReview ? "Ancora nessuna recensione. Scrivi la prima!" : "Ancora nessuna recensione."}
            </div>
          ) : (
            <ul
              style={{
                listStyle: "none",
                margin: 0,
                padding: 12,
                display: "grid",
                gap: 10,
              }}
            >
              {list.map((r) => (
                <li
                  key={r.id}
                  style={{
                    border: "1px solid #eee",
                    borderRadius: 10,
                    padding: 10,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 6,
                    }}
                  >
                    <strong>
                      {"★".repeat(r.rating)}
                      {"☆".repeat(5 - r.rating)}
                    </strong>
                    <span style={{ color: "#666", fontSize: 12 }}>
                      {new Date(r.created_at).toLocaleString("it-IT")}
                    </span>
                  </div>
                  {r.user_name && (
                    <div
                      style={{ fontSize: 12, color: "#333", marginBottom: 4 }}
                    >
                      di {r.user_name}
                    </div>
                  )}
                  {r.comment && (
                    <div style={{ whiteSpace: "pre-wrap" }}>{r.comment}</div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>

        {!canReview && eligibility?.reason && (
          <div style={{ ...formBox, color: "#666", fontSize: 14 }}>
            {eligibility.reason}
          </div>
        )}

        {canReview && (
        <form onSubmit={submitReview} style={formBox}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 8,
            }}
          >
            <label style={{ fontWeight: 700 }}>
              {hasMyReview ? "Modifica il tuo voto:" : "Il tuo voto:"}
            </label>
            <div>
              {[1, 2, 3, 4, 5].map((n) => (
                <button
                  key={n}
                  type="button"
                  onClick={() => setMyRating(n)}
                  style={{
                    ...starBtn,
                    color: n <= myRating ? "#f1b400" : "#ccc",
                  }}
                  aria-label={`${n} stelle`}
                >
                  ★
                </button>
              ))}
            </div>
          </div>
          <textarea
            value={myComment}
            onChange={(e) => setMyComment(e.target.value)}
            placeholder="La tua esperienza (opzionale)"
            rows={3}
            style={textArea}
          />
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <button type="button" onClick={onClose} style={btnGhost}>
              Annulla
            </button>
            <button type="submit" style={btnPrimary}>
              {hasMyReview ? "Aggiorna" : "Invia"}
            </button>
          </div>
        </form>
        )}
      </aside>
    </div>
  );
}

/* ---- styles ---- */
const backdrop = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,.35)",
  zIndex: 3000,
  display: "flex",
  justifyContent: "flex-end",
};
const panel = {
  width: "min(92vw, 520px)",
  height: "100%",
  background: "#fff",
  boxShadow: "-10px 0 40px rgba(0,0,0,.25)",
  display: "flex",
  flexDirection: "column",
};
const panelHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 14px",
  borderBottom: "1px solid #eee",
};
const xBtn = {
  border: "none",
  background: "transparent",
  fontSize: 20,
  cursor: "pointer",
};
const formBox = { padding: 12, borderTop: "1px solid #eee" };
const starBtn = {
  border: "none",
  background: "transparent",
  fontSize: 22,
  cursor: "pointer",
};
const textArea = {
  width: "100%",
  border: "1px solid #ccc",
  borderRadius: 8,
  padding: "8px 10px",
  resize: "vertical",
};
const btnPrimary = {
  border: "none",
  background: "#007bff",
  color: "#fff",
  borderRadius: 8,
  padding: "8px 12px",
  cursor: "pointer",
  fontWeight: 700,
};
const btnGhost = {
  border: "1px solid #ccc",
  background: "#fff",
  borderRadius: 8,
  padding: "8px 12px",
  cursor: "pointer",
  fontWeight: 700,
};
